import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormComponentOptions } from '../form/form-component-options.model';
import { FormType } from '../form/form-type-enum';
import { Store } from '@ngrx/store';
import { SubmitEditTransactionForm } from '../../core/store/user/actions/edit-transaction-form.actions';
import { EditWithdrawTransaction } from '../../core/transactions/transactions.types';
import { iso2CountryValidator, nonNumericValidator } from './edit-transaction-form.validators';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { selectTransactionActions } from '../../core/store/user/selectors/transaction-actions.selector';

@Component({
    selector: 'app-edit-transaction-form',
    templateUrl: './edit-transaction-form.component.html',
    styleUrls: ['./edit-transaction-form.component.scss'],
    animations: [
        trigger('submitAnimation', [
            state('submitted', style({
                opacity: '0.5',
                transform: 'scale(0.95)'
            })),
            state('notSubmitted', style({
                opacity: '1',
                transform: 'scale(1.0)'
            })),
            transition('notSubmitted => submitted', [
                animate('500ms ease-out')
            ]),
            transition('submitted => notSubmitted', [
                animate('500ms ease-in')
            ])
        ])
    ]
})
export class EditTransactionFormComponent implements OnInit {
    readonly formTitle: string = 'Edit Transaction Data';
    @Input() transactionId: string;

    options: FormComponentOptions[] = [
        {
            name: 'First Name',
            slug: 'firstName',
            placeholder: 'Jane',
            validator: [
                {
                    validate: nonNumericValidator(),
                    slug: 'containsNumeric',
                    errorMessage: 'Must not contain numbers'
                }
            ],
            type: FormType.Text,
        },
        {
            name: 'Last Name',
            slug: 'lastName',
            placeholder: 'Doe',
            validator: [
                {
                    validate: nonNumericValidator(),
                    slug: 'containsNumeric',
                    errorMessage: 'Must not contain numbers'
                }
            ],
            type: FormType.Text,
        },
        {
            name: 'Address',
            slug: 'address1',
            placeholder: 'Street 165 / 13',
            validator: [],
            type: FormType.Text,
        },
        {
            name: 'Country',
            slug: 'country',
            placeholder: 'GB',
            validator: [
                {
                    validate: iso2CountryValidator(),
                    slug: 'invalidIso2Country',
                    errorMessage: 'ISO 2 country codes only'
                },
                {
                    validate: nonNumericValidator(),
                    slug: 'containsNumeric',
                    errorMessage: 'Must not contain numbers'
                }
            ],
            type: FormType.Text,
        },
        {
            name: 'Post Code',
            slug: 'zip_code',
            placeholder: 'ZW80100',
            validator: [],
            type: FormType.Text,
        },
    ];
    isSubmitted: boolean = false;
    isDialog: boolean = false;

    constructor(
        private store: Store,
        @Inject(MAT_DIALOG_DATA) public data: { transactionId: string }
    ) {
    }

    ngOnInit(): void {
        if (this.data && this.data.transactionId) {
            this.transactionId = this.data.transactionId;
            this.isDialog = true;
        }
        this.getFormFieldValues();
    }

    getFormFieldValues() {
        this.store.select(selectTransactionActions(this.transactionId)).subscribe((actions) => {
            const currentActionMetadata = {...actions.find(action => action.metadata).metadata};

            this.options = this.options.map((option) => {
                if (currentActionMetadata.hasOwnProperty(option.slug)) {
                    return {...option, value: currentActionMetadata[option.slug]};
                } else {
                    return option;
                }
            });
        }).unsubscribe();
    }

    submittedForm(form: EditWithdrawTransaction) {
        Object.keys(form).forEach(key=>{
            if(!form[key]?.trim()){
                delete form[key]
            }
        })
        const fullForm: EditWithdrawTransaction = {...form, transactionId: this.transactionId};
        this.isSubmitted = true;
        this.store.dispatch(new SubmitEditTransactionForm(fullForm));
        setTimeout(() => {
            this.isSubmitted = false;
        }, 1000);
    }
}
